import React, { useState } from 'react';
import { Container, Card, Button, Modal, Form } from 'react-bootstrap';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { Link } from 'react-router-dom';
import '@splidejs/react-splide/css';
import { apiFetch, API_URL } from '../../utils/api';
import './services.css';
import ConsultationBlock from '../cta/ConsultationBlock';

function Services({ cards }) {
  const [show, setShow] = useState(false);
  const [cardModal, setCardModal] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [firstName, setName] = useState('');
  const [phone, setPhone] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = (card) => { setCardModal(card); setShow(true); };

  const handleCloseForm = () => setShowForm(false);
  const handleShowForm = () => setShowForm(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await apiFetch('/api/send-mail', {
        method: "POST",
        body: JSON.stringify({ name: firstName, phone })
      });
      
      // Баг #11/ESLint: убрали 'const data = ...', так как мы ее не используем здесь
      if (res.status === 422) {
        alert("Ошибка: Пожалуйста, введите корректный номер телефона (только цифры).");
        return;
      }

      if (res.status === 429) {
        alert("Слишком много заявок. Пожалуйста, подождите минуту.");
        return;
      }

      if (res.ok) {
        alert("Заявка принята! Мы перезвоним вам.");
        handleCloseForm();
        setName(""); setPhone("");
      }
    } catch (err) {
      alert("Ошибка соединения с сервером");
    }
  };

  if (!cards || cards.length === 0) return null;

  return (
    <>
      {/* СЕКЦИЯ УСЛУГ */}
      <section className="section-services">
        <Container>
          <div className="text-center mb-5">
            <h2 className="section-title">Наши услуги</h2>
            <p className="section-subtitle">Выполняем полный цикл строительных и ландшафтных работ с гарантией качества</p>
          </div>
          
          <div className="slider-container mb-5">
            <Splide options={{
              type: 'loop', perMove: 1, gap: '2rem', pagination: false, arrows: true, drag: true, perPage: 3,
              breakpoints: { 1024: { perPage: 2 }, 768: { perPage: 1, gap: 0 } }
            }}>
              {cards.map(card => (
                <SplideSlide key={card.card_id} className="py-2">
                  <Card className='corp-card h-100' onClick={() => handleShow(card)} style={{ cursor: 'pointer' }}>
                    <div className='ratio ratio-1x1 overflow-hidden'>
                      <Card.Img variant="top" className='object-fit-cover' src={`${API_URL}/${card.image}`} />
                    </div>
                    <Card.Body className="d-flex flex-column p-4">
                      <div className="text-accent small fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                          {card.category?.name || 'Услуга'}
                      </div>
                      <Card.Title className="fw-bold mb-3">{card.title}</Card.Title>
                      <Card.Text className='truncate-multiline small text-muted mb-4'>{card.description}</Card.Text>
                      <div className='mt-auto pt-3 border-top d-flex justify-content-between align-items-center'>
                        <span className="fw-bold fs-5 text-dark">от {card.price} ₽</span>
                        <span className="text-accent fw-bold small text-uppercase" style={{fontSize: '0.7rem'}}>Подробнее <i className="bi bi-arrow-right ms-1"></i></span>
                      </div>
                    </Card.Body>
                  </Card>
                </SplideSlide>
              ))}
            </Splide>
          </div>

          <div className="text-center mt-5"> {/* Добавили mt-5 для отступа от слайдера */}
            <Button as={Link} to="/catalog" variant="outline-dark" className="px-5 py-3 rounded-1 fw-bold text-uppercase small border-2">
              Перейти в полный каталог
            </Button>
          </div>
        </Container>
        {/* Добавим пустой div или padding снизу секции, чтобы кнопка не была в самом низу */}
        <div className="pb-5"></div> 
      </section>

      <ConsultationBlock />

      {/* Модалки (оставляем, они функциональны) */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">{cardModal.title}</Modal.Title></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className='ratio ratio-16x9 mb-4 rounded-2 overflow-hidden shadow-sm'><img className='object-fit-cover' src={`${API_URL}/${cardModal.image}`} alt=""/></div>
          <p className="text-muted fs-5 lh-lg">{cardModal.description}</p>
          <div className="d-flex justify-content-between align-items-center bg-light p-4 rounded-3 mt-4">
             <div>
                <div className="text-muted small text-uppercase fw-bold">Ориентировочно</div>
                <div className="fs-2 fw-bold text-accent">от {cardModal.price} ₽</div>
             </div>
             <Button className="btn-corp px-5" onClick={() => { handleClose(); handleShowForm(); }}>Заказать</Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showForm} onHide={handleCloseForm} centered>
        <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Заявка на расчет</Modal.Title></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted">Как вас зовут?</Form.Label>
              <Form.Control className="bg-light border-0 py-3 shadow-none" placeholder="Имя" value={firstName} onChange={e => setName(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold text-muted">Ваш номер телефона</Form.Label>
              <Form.Control className="bg-light border-0 py-3 shadow-none" placeholder="+7" value={phone} onChange={e => setPhone(e.target.value)} required />
            </Form.Group>
            <Button type='submit' className="btn-corp w-100 py-3 fw-bold">ОТПРАВИТЬ ЗАЯВКУ</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Services;
